import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-hardware',
  templateUrl: './hardware.component.html',
  styleUrls: ['./hardware.component.scss']
})
export class HardwareComponent implements OnInit {

  fragment = null;

  constructor(
      private route: ActivatedRoute,
      private router: Router
    ) { }

  ngOnInit() {
    this.route.fragment.subscribe(fragment => { this.fragment = fragment; });
  }

  ngAfterViewChecked(): void {
    if (this.fragment) {
      const fragmentElement = document.getElementById(this.fragment);
      if (fragmentElement) {
        let yOffset = 0;

        const topBarElement = document.getElementById('topBar');
        if (topBarElement) {
          yOffset = topBarElement.getBoundingClientRect().top + topBarElement.getBoundingClientRect().height + 24;
        }

        const y = fragmentElement.getBoundingClientRect().top + window.pageYOffset - yOffset;
        window.scrollTo({top: y});
      }
      this.fragment = null;
    }

  }

}
